export const permission = {
  MYMEDAX_SETTING_CREATE: 'MYMEDAX_SETTING_CREATE',
  MYMEDAX_SETTING_READ: 'MYMEDAX_SETTING_READ',
  MYMEDAX_SETTING_UPDATE: 'MYMEDAX_SETTING_UPDATE',
  MYMEDAX_SETTING_DELETE: 'MYMEDAX_SETTING_DELETE'
};

